import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _toConsumableArray from "E:/hongyou/background_ui/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "E:/hongyou/background_ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// list-列表, add-添加, update-更新, delete-删除,
// info-详情, data-下拉框, tab-选修卡
var APIURL = {
  test: {
    list: '',
    add: '',
    update: '',
    delete: '',
    info: ''
  },
  a: {},
  account: {
    password: {
      update: '/user/pwd',
      reset: '/sysUser'
    },
    user: {
      update: '/sysUser/profile',
      info: '/user/profile'
    },
    status: {
      update: '/sysUser'
    },
    userTemplate: {
      download: '/sysUser/importTemplate'
    }
  },
  alarm: _objectSpread(_objectSpread({}, toTableApi('/alarm')), {}, {
    list: '/alarm/list',
    add: '/alarm/add',
    update: '/alarm/update',
    info: '/alarm/info'
  }),
  alarmSet: {
    // 告警设置
    // ...toDiffModeApi('/alarm/set'),
    rdc4m: {
      list: '/alarm/set/list',
      // 告警-设置
      info: '/alarm/set/info',
      add: '/alarm/set/add',
      update: '/alarm/set/update',
      delete: '/alarm/set/del',
      11: '/alarm/set/rdc4m/list',
      // 集中-告警设置
      12: '/alarm/set/rdc4m/info',
      13: '/alarm/set/rdc4m/add',
      14: '/alarm/set/rdc4m/update',
      15: '/alarm/set/rdc4m/del'
    },
    rdcsm: {
      list: '/alarm/setList',
      add: '/alarm/addSet',
      update: '/alarm/updateSet',
      delete: '/alarm/delData',
      info: '/alarm/set/rdcsm/info'
    }
  },
  alarmRead: {
    one: '/alarm/number/single',
    batch: '/alarm/number/batch',
    clear: '/alarm/number/clear'
  },
  area: {
    // 区域
    // toTableApi('/area/set'),
    list: '/area/set/list',
    info: '/area/set/info',
    add: '/area/set/add',
    update: '/area/set/update',
    delete: '/area/set/del',
    data: '/area/set/data' // 下拉框，
  },

  b: {},
  c: {},
  d: {},
  dispatch: {
    list: '/dispatch/myDispatchList',
    add: '/dispatch/addDistributeLeaflets',
    update: '/dispatch/updateDistributeLeaflets',
    delete: '/policy/delData',
    info: '/policy/getData'
  },
  e: {},
  electricitySet: {
    // 集中-额定电流/电压 ct1~4等设置列表
    // toTableApi('/electricity/set/'),
    list: '/electricity/set/list',
    info: '/electricity/set/info',
    add: '/electricity/set/add',
    update: '/electricity/set/update',
    delete: '/electricity/set/del'
  },
  f: {},
  g: {},
  h: {},
  heart: {
    // 招测
    send: {
      // 招测-下发
      all: '/terminal/heart/send/all',
      one: '/terminal/heart/send/:terminalId'
    },
    rdc4m: {
      // 招测-单灯
      list: '/heartList',
      info: '/heartInfo'
    },
    rdcsm: {
      // 招测-集中
      list: '/rdcsm/heartList',
      info: '/rdcsm/heartInfo'
    },
    data: {
      // 招测-实时数据
      rdcsm: {
        // 招测-实时数据-单灯
        list: '/heart/data/list/rdcsm',
        info: '/heart/data/info/rdcsm'
      },
      rdc4m: {
        // 招测-实时数据-集中
        list: '/heart/data/list/rdc4m',
        info: '/heart/data/info/rdc4m'
      }
    }
  },
  heartLog: {
    single: {
      list: '/rdcsm/hearttestLog',
      info: '/rdcsm/hearttestLogInfo'
    },
    integrate: {
      list: '/hearttestLog',
      info: '/hearttestLogInfo'
    }
  },
  i: {},
  imsi: {
    // imsi流量通讯卡
    now: '/imsi/position/location/now',
    // imsi流量通讯卡-获取实时定位信息
    last: '/imsi/position/location/last',
    // imsi流量通讯卡-最后一次上网位置
    lastA: '/imsi/position/location/a/last' // imsi流量通讯卡-A类最后一次上网位置
  },

  j: {},
  k: {},
  l: {},
  log: {
    // 日志
    alarm: {
      // 告警日志
      list: '/alarm/log/list',
      delete: '/alarm/log/del',
      nList: '/alarm/list',
      nDtlList: '/alarm/desc/list'
    },
    deviceOnlinState: {
      // 设备状态（在线/离线）日志
      list: '/log/unline/list'
    },
    gmt: {
      // 地理位置日志
      list: '/log/gmt/list',
      info: '/log/gmt/info'
    },
    heart: {
      rdc4m: {
        // 设备-集中-招测日志
        list: '/log/heart/list/rdc4m',
        info: '/log/heart/info/rdc4m'
      },
      rdcsm: {
        // 设备-单灯-招测日志
        list: '/log/heart/list/rdcsm',
        info: '/log/heart/info/rdcsm'
      }
    },
    init: {
      // 设备-初始化日志
      list: '/log/init/list',
      info: '/log/init/info'
    },
    leakage: {
      // 设备-集中-漏电流脱扣日志
      list: '/log/leakage/list',
      info: '/log/leakage/info'
    },
    lock: {
      // 锁日志
      list: '/log/lock/list',
      info: '/log/lock/info'
    },
    onlineState: {
      // 设备-离线/在线日志
      list: '/log/status/list',
      info: '/log/status/info'
    },
    timing: {
      // 校时日志
      list: '/log/timing/list',
      info: '/log/timing/info'
    }
  },
  m: {},
  maintenance: toTableApi('/maintenance/set'),
  // 维护部门
  n: {},
  o: {},
  overcurrent: {
    one: '/over/current/data/:terminalId' // 根据设备id获取过流数据
  },

  p: {},
  plan: {
    // 排班
    info: '/plan/info',
    // 排班-列表
    add: '/plan/add' // 排班-新建/更新
  },

  planEmergency: {
    // 排班-紧急人员
    info: '/plan/emergency/info',
    // 排班-紧急人员-查询
    add: '/plan/emergency/add' // 排班-紧急人员-新建/更新
  },

  policy: {
    // 策略
    // ...toTableApi(),
    task: '/policy/task',
    // 策略定时任务
    list: '/policy/list',
    add: '/policy/add',
    update: '/policy/update',
    delete: '/policy/del',
    info: '/policy/info'
  },
  policyTemplate: _objectSpread(_objectSpread({}, toDiffModeApi('/policy/template')), {}, {
    all: '/policy/template/all' // 策略模板-所有
    // rdcsm: {  // 策略模板-单灯
    //   list: '/policy/template/rdcsm/list',
    //   add: '/policy/template/rdcsm/add',
    //   update: '/policy/template/rdcsm/update',
    //   delete: '/policy/template/rdcsm/delm',
    //   info: '/policy/template/rdcsm/info'
    // },
    // rdc4m: {  // 策略模板-集中
    //   list: '/policy/template/rdc4m/list',
    //   add: '/policy/template/rdc4m/add',
    //   update: '/policy/template/rdc4m/update',
    //   delete: '/policy/template/rdc4m/del',
    //   info: '/policy/template/rdc4m/info'
    // }
  }),

  q: {},
  query: {
    terminal: '/query/terminals',
    template: '/query/template'
  },
  r: {},
  s: {},
  schedule: {
    // 排班
    list: '/plan/list',
    // 排班-列表
    update: '/plan/add' // 排班-新建/更新
  },

  scheduleEmergency: {
    // 排班-紧急人员
    update: '/plan/emergency/add',
    // 排班-紧急人员-新建/更新
    info: '/plan/emergency/info' // 排班-紧急人员-查询
  },

  send: {
    // 下发
    rdcsm: {
      // 下发-单灯
      initAll: '/send/set/init/rdcsm/data',
      // 单灯-初始化所有
      initOne: '/send/set/init/rdcsm/id',
      // 单灯-根据id初始化
      manauto: '/send/set/manauto/rdcsm',
      // 单灯-远程手动/自动模式设置
      gmt: '/send/set/gmt/rdcsm',
      // 单灯-地理位置设置
      overcurrent: '/send/set/over/current/rdcsm',
      // 单灯-过流保护设置
      time: '/send/set/time/rdcsm/:terminalId',
      // 单灯-校时
      alarm: '/send/set/alarm/rdcsm',
      // 单灯-告警设置
      relay: '/send/set/relay/rdcsm',
      // 单灯-开关模式、时间及时段调光设置
      1: '/send/set/heart/info/rdcsm' // 单灯-设置电气设置（额定信息）
    },

    rdc4m: {
      // 下发-集中
      initAll: '/send/set/init/rdc4m/all',
      // 集中-初始化所有
      initOne: '/send/set/init/rdc4m/id',
      // 集中-根据id初始化
      initInfo: '/send/set/init/rdc4m/info',
      // 集中-初始化详情
      manauto: '/send/set/manauto/rdc4m/:terminalId',
      // 集中-远程手动/自动模式设置
      manautoRecover: '/send/set/manauto/recover/rdc4m/:terminalId',
      // 集中-恢复自动
      gmt: '/send/set/gmt/rdc4m',
      // 集中-地理位置设置
      overcurrent: '/send/set/over/current/rdc4m',
      // 集中-过流保护设置
      time: '/send/set/time/rdc4m/:terminalId',
      // 集中-校时
      alarm: '/send/set/alarm/rdc4m',
      // 集中-告警设置
      relay: '/send/set/relay/rdc4m/info',
      // 集中-开关模式、时间及时段调光设置
      leakage: '/send/set/leakage/rdc4m',
      // 集中-漏电保护
      lock: '/send/set/lock/rdc4m' // 集中-锁
    }
  },

  setting: {
    // 设置
    manauto: {
      info: '/queryManautoData'
    },
    terminal: {}
  },
  statistics: {
    power: '/heart/data/rdc4m/statistics'
  },
  strategySet: {
    // 群组
    // ...toTableApi('/strategy/set'),
    default: '/strategy/set/default',
    // 默认 这是啥？
    list: '/strategy/set/list',
    add: '/strategy/set/add',
    update: '/strategy/set/update',
    delete: '/strategy/set/del',
    info: '/strategy/set/info',
    data: '/strategy/set/data',
    one: '/strategy/set/terminal/info',
    // 根据设备id获取
    oneUpdate: '/strategy/set/terminal/update' // 根据设备id修改 ????
  },

  sysUser: {
    list: '/sysUserList',
    info: '/sysUser/:userId',
    init: '/sysUser/',
    add: '/sysUser',
    update: '/sysUser',
    delete: '/sysUser/:userId',
    export: '/sysUser/export'
  },
  t: {},
  terminal: _objectSpread(_objectSpread(_objectSpread({}, toTableApi('/terminal')), toDiffModeApi('/terminal')), {}, {
    inventory: toTableApi('/terminal/inventory'),
    // 设备库存/设备仓储列表

    11: '/terminal/datas',
    // 所有设备-下拉框
    query: '/terminal/query',
    // 策略设备下拉框数据
    imgs: '/terminal/imgs',
    list: '/terminal/list',
    // 设备-列表
    repair: '/terminal/repair/list',
    // 维修列表  --新添加
    replace: '/terminal/repair/replace',
    // 替换设备 ---新添加
    box: '/terminal/box/list',
    // 箱体列表 ---新添加 '/terminal/box/list'也可以用
    addBox: '/terminal/box/add',
    // 添加箱体 ---新添加
    boxInfo: '/terminal/box/info',
    // 箱体详情 ---新添加
    updateBox: '/terminal/box/update',
    // 修改箱体 ---新添加
    notContactList: 'terminal/box/unMount/list',
    // 未挂载箱体的终端列表 ---新添加
    contactList: '/terminal/box/mount/list',
    // 挂载过箱体的终端列表 ---新添加
    mountDevice: '/terminal/box/mount',
    // 挂载设备 ---新添加
    info: '/terminal/info',
    // 设备-
    add: '/terminal/add',
    // 设备-
    update: '/terminal/edit',
    // 设备-
    delete: '/terminal/del',
    // 设备-
    tab: '/terminal/tab',
    // 设备-选项卡数据
    status: '/terminal/status/update',
    // 设备-修改状态
    registered: '/terminal/registered',
    // 设备注册

    data: {
      // 设备-招测实时数据
      rdcsm: {
        list: '/terminal/list/rdcsm',
        info: '/terminal/info/rdcsm'
      },
      rdc4m: {
        list: '/terminal/list/rdc4m',
        info: '/terminal/info/rdc4m',
        data: '/terminal/data/rdc4m'
      }
    },
    heart: {
      // 设备-下发招测
      all: '/terminal/heart/send/all',
      one: '/terminal/heart/send/:terminalId'
    },
    set: {
      // 设备-设置
      rdc4m: {
        // 设置-集中
        alarm: _objectSpread(_objectSpread({}, toTableApi('/terminal/set/alarm/rdc4m', ['list', 'info'])), {}, {
          reset: '/set/alarm/rdc4m/reset'
        }),
        //  集中-告警
        elc: toTableApi('/terminal/set/elc/rdc4m', ['list', 'info']),
        // 集中-额定电流/电压 ct1~4等
        elec: toTableApi('/terminal/set/elec/rdc4m', ['list', 'info']),
        // 集中-集中-额定电流/电压 ct1~4等
        leakage: toTableApi('/terminal/set/leakage/rdc4m', ['list', 'info']),
        // 集中-漏电保护
        lock: toTableApi('/terminal/set/lock/rdc4m', ['list', 'info']),
        // 集中-锁
        manauto: toTableApi('/terminal/set/manauto/rdc4m', ['list', 'info']),
        // 集中-手动/自动
        overCurrent: toTableApi('/terminal/set/over/current/rdc4m', ['list', 'info']),
        // 集中-过流保护
        relay: toTableApi('/terminal/set/relay/rdc4m', ['list', 'info']) // 集中-开关模式、时间及时段调光设置
      },

      rdcsm: {
        // 设备-设置-单灯
        alarm: _objectSpread(_objectSpread({}, toTableApi('/terminal/set/alarm/rdcsm', ['list', 'info'])), {}, {
          reset: '/set/alarm/rdc4m/reset'
        }),
        // 单灯-告警
        elc: toTableApi('/terminal/set/elc/rdcsm', ['list', 'info']),
        // 单灯-电气设置（额定信息）
        overCurrent: toTableApi('/terminal/set/over/current/rdcsm', ['list', 'info']),
        // 单灯-过流保护
        relay: toTableApi('/terminal/set/relay/rdcsm', ['list', 'info']) // 单灯-开关模式、时间及时段调光设置
      }
    }
  }),

  u: {},
  user: {
    // 用户
    login: '/api/login',
    // 用户-登录 (无baseURL)
    logout: '/logout',
    // 用户-登出
    refreshtoken: '/refreshtoken',
    // 用户-token (无baseURL)
    info: '/getinfo',
    // 用户-信息
    captcha: '/getCaptcha',
    // 用户-登录-校验码
    checkpwd: '/user/checkpwd' // // 用户-下发时候密码校验 (无baseURL)
  },

  userAvatar: {
    upload: '/user/avatar'
  },
  v: {},
  w: {},
  ws: {
    // 长连接
    alarm: '/ws/alarm/:uniqueId/:userId',
    // 告警
    msg: '/ws/msg/:uniqueId/:userId' // 设备数据
  },

  x: {},
  y: {},
  z: {}
};
function toTableApi(url) {
  var enums = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  // list-列表, add-添加, update-更新, delete-删除,
  // info-详情, data-下拉框, tab-选修卡
  var typePrefixReserve = ['list', 'add', 'update', 'delete', 'info', 'data', 'tab'];
  var typePrefix = [];
  if (mode) typePrefix = !enums.length ? typePrefixReserve : enums;else typePrefix = _toConsumableArray(new Set(typePrefixReserve.push(enums)));
  var itemApi = {};
  if (url instanceof Object) {
    Object.keys(url).forEach(function (item) {
      itemApi[item] = toTableApi(url[item], enums, mode);
    });
  } else {
    typePrefix.forEach(function (item) {
      itemApi[item] = "".concat(url, "/").concat(item);
    });
  }
  return itemApi;
}
function toDiffModeApi(url) {
  var enums = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var diffMode = ['rdc4m', 'rdcsm'];
  var apis = {
    all: "".concat(url, "/all")
  };
  diffMode.forEach(function (item) {
    apis[item] = toTableApi(url, enums, mode);
  });
  return apis;
}
export default APIURL;